import React from "react";
import PersonsPage from "@/pages/admin/PersonsPage";

export default function ExecutiveBody() {
  return (
    <PersonsPage
      bodyType="executive_body"
      title="Executive Body"
      subtitle="Trust governance"
      intro="Trustees who form the executive body — designation, contact, identity, and tenure."
      prefix="executive"
      showPassword
    />
  );
}
